export default function(id, fields) {
  const data = {
    description: fields.description,
    duration: Number(fields.duration) * 60,
    date: fields.date,
    name: fields.name,
    activity: {
      id
    }
  }

  if (!id) {
    data.activity = undefined
  }

  return data
}
